<v-app>
  <v-main>
    <BreadCrumb />
    
    <router-view />
  </v-main>
</v-app>